<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.65,799.89v-3.7h-1.84v-1.85H2.5v1.85l4.93-3.69l-4.93-3.69v1.85h-3.69v-1.85h1.84v-3.69l9.85,7.39L0.65,799.89z
	 M-9.5,796.19v-1.85h1.85v1.85H-9.5z M-5.81,796.19v-1.85l2.77,0v1.85L-5.81,796.19z M-9.5,790.66v-1.85h1.85v1.85H-9.5z
	 M-5.81,790.66v-1.85l2.77,0v1.85L-5.81,790.66z"/>
</svg>

</template>